import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useSelector } from "react-redux"
import { isRamakKalaAuthorized } from '../helper/authorizedUsers'

const RamakKalaRoute = () => {

  const { currentUser } = useSelector((state) => state.auth)

  // Kullanıcı login değilse login sayfasına yönlendir
  if (!currentUser) {
    return <Navigate to="/login" />
  }

  // Kullanıcı Ramak Kala erişimine yetkili değilse erişim reddedildi sayfasına yönlendir
  if (!isRamakKalaAuthorized(currentUser)) {
    return <Navigate to="/access-denied" />
  }

  // Yetkili kullanıcı için içeriği göster
  return <Outlet />
}

export default RamakKalaRoute
